const snakeToCamelCase = (obj) => {
  const newObj = {};
  Object.keys(obj).forEach((key) => {
    const newKey = key.replace(/(_\w)/g, (k) => k[1].toUpperCase());
    newObj[newKey.toString()] = obj[key.toString()];
  });
  return newObj;
};
export default snakeToCamelCase;
